import React from 'react';
import Icon from '../../../components/AppIcon';

const Core4MetricCard = ({ 
  title, 
  icon, 
  completedCount, 
  loggedDays, 
  percentage, 
  color = 'primary',
  sparklineData = [],
  currentStreak = 0,
  showSparkline = true,
  showStreak = true 
}) => {
  const colorClasses = {
    primary: 'text-primary bg-primary/10 border-primary/20',
    secondary: 'text-secondary bg-secondary/10 border-secondary/20',
    accent: 'text-accent bg-accent/10 border-accent/20',
    success: 'text-success bg-success/10 border-success/20'
  };

  const iconColorClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    accent: 'text-accent',
    success: 'text-success'
  };

  // Generate simple sparkline path
  const generateSparklinePath = (data) => {
    if (!data || data?.length === 0) return '';
    
    const width = 60;
    const height = 20;
    const max = Math.max(...data, 1);
    
    const points = data?.map((value, index) => {
      const x = (index / (data?.length - 1)) * width;
      const y = height - (value / max) * height;
      return `${x},${y}`;
    });
    
    return `M ${points?.join(' L ')}`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-gentle hover:shadow-gentle-hover transition-all duration-200 animate-spring">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <div className={`p-2 rounded-lg ${colorClasses?.[color]}`}>
            <Icon 
              name={icon} 
              size={18} 
              className={iconColorClasses?.[color]}
            />
          </div>
          <h3 className="font-heading font-semibold text-foreground">{title}</h3>
        </div>
        
        {showSparkline && sparklineData?.length > 0 && (
          <div className="w-16 h-6">
            <svg width="60" height="20" className="overflow-visible">
              <path
                d={generateSparklinePath(sparklineData)}
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className={iconColorClasses?.[color]}
              />
            </svg>
          </div>
        )}
      </div>
      {/* Main Metrics */}
      <div className="space-y-2">
        <div className="flex items-baseline space-x-2">
          <span className="text-2xl font-heading font-bold text-foreground">
            {completedCount}
          </span>
          <span className="text-sm text-muted-foreground">
            / {loggedDays} days
          </span>
        </div>
        
        <div className="flex items-center space-x-2">
          <div className="flex-1 bg-muted rounded-full h-2">
            <div 
              className={`h-2 rounded-full transition-all duration-300 ${
                color === 'primary' ? 'bg-primary' :
                color === 'secondary' ? 'bg-secondary' :
                color === 'accent'? 'bg-accent' : 'bg-success'
              }`}
              style={{ width: `${Math.min(percentage, 100)}%` }}
            />
          </div>
          <span className="text-sm font-medium text-foreground">
            {percentage?.toFixed(1)}%
          </span>
        </div>
      </div>
      {/* Streak Counter */}
      {showStreak && currentStreak > 0 && (
        <div className="mt-3 pt-3 border-t border-border">
          <div className="flex items-center space-x-2">
            <Icon name="Flame" size={14} className="text-warning" />
            <span className="text-xs text-muted-foreground">
              {currentStreak} day streak
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Core4MetricCard;